import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Segment, Table } from 'semantic-ui-react';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import numeral from 'numeral';
import { authService } from '../../utils/auth-service';

class ProfileApiData extends Component {

  constructor() {
    super();

    this.state = {
      apiInfluencer: null,
      loading: true,
      error: null,
    };

    this.restClient = axios.create({
      timeout: 1000,
      headers: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });

    axiosRetry(this.restClient, {
      retries: 3,
    });
  }

  componentDidMount = () => {
    const immutableApiLink = this.props.influencerApiLink;
    const jsLink = immutableApiLink.toJS();

    this.restClient.get(jsLink.url)
      .then(response => {
        const apiInfluencer = response.data.influencer;
        this.setState({
          loading: false,
          apiInfluencer,
        });
      })
      .catch(e => {
        this.setState({
          error: e,
        });
      });
  }

  render = () => {
    const { apiInfluencer, loading, error } = this.state;
    const cf = num => numeral(num).format('0,0');
    const stats = apiInfluencer && apiInfluencer.aggregateYoutubeChannelStatistics;

    return (
      <Segment padded loading={loading}>
        <h3>Youtube Data</h3>
        {
          apiInfluencer &&
          <Table basic="very" fluid>
            <Table.Body>
              <Table.Row>
                <Table.Cell>channels</Table.Cell>
                <Table.Cell>{stats.channelCount}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>videos</Table.Cell>
                <Table.Cell>{cf(stats.videoCount)}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>subscribers</Table.Cell>
                <Table.Cell>{cf(stats.subscriberCount)}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>views</Table.Cell>
                <Table.Cell>{cf(stats.viewCount)}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>comments</Table.Cell>
                <Table.Cell>{cf(stats.commentCount)}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>avg. views per video</Table.Cell>
                <Table.Cell>{cf(stats.viewCount / stats.videoCount)}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>avg. comments per video</Table.Cell>
                <Table.Cell>{cf(stats.commentCount / stats.videoCount)}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>avg. daily viewing</Table.Cell>
                <Table.Cell>{cf(stats.averageDailyViews)}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>avg. monthly viewing</Table.Cell>
                <Table.Cell>{cf(stats.averageMonthlyViews)}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        }
        {
          error && error.message
        }
      </Segment>
    );
  }

}


ProfileApiData.propTypes = {
  influencerApiLink: PropTypes.object.isRequired,
};

export default ProfileApiData;



/** WEBPACK FOOTER **
 ** ./src/containers/influencer-profile/profile-api-data.js
 **/